/*
 * @Author: wangkg
 * @LastEditors: 黄昱森
 * @Description: 常量
 */

import {
  MENU_BACKGROUND_COLOR,
  MENU_BACKGROUND_ACTIVE_COLOR,
  MENU_BACKGROUND_HOVER_COLOR,
  MENU_TEXT_COLOR,
  MENU_TEXT_ACTIVE_COLOR,
  MENU_TEXT_HOVER_COLOR,
  MENU_TEXT_FONT_SIZE
} from '@/constants/pc/root-css'

export const MENU_LAYOUT_MAP = {
  top: 'horizontal',
  left: 'vertical',
  hide: ''
}
// 菜单打开时宽度
export const LC_MENU_OPEN_WIDTH = 200
// 菜单折叠时宽度
export const LC_MENU_CLOSE_WIDTH = 64

export const LC_MENU_DEFAULT_MAP = {

}

// menu 相关配置项 
export const LC_MENU_DEFAULT = {
  [MENU_BACKGROUND_COLOR]: 'rgb(4, 51, 107)',
  [MENU_BACKGROUND_ACTIVE_COLOR]: 'blue',
  [MENU_BACKGROUND_HOVER_COLOR]: 'red',
  [MENU_TEXT_COLOR]: '#fff',
  [MENU_TEXT_ACTIVE_COLOR]: '#fff',
  [MENU_TEXT_HOVER_COLOR]: '#fff',
  [MENU_TEXT_FONT_SIZE]: '18px',
}

export const AUTH_CODE_LIST = 'AUTH_CODE_LIST'